import { useApi } from "@/lib/api"
import { CommissionPlanConfiguration } from "@/models/interface"

export const useCommissionPlanApi = () => {
    const { adminApi, commissionPlanApi } = useApi()

    const fetchCommissionPlans = async () => {
        try {
            const response = await adminApi.get<CommissionPlanConfiguration[]>(
                '/GlobalConfiguration/Configuration/CommissionPlanConfiguration'
            )
            return response
        } catch (error) {
            console.error('❌ Error fetching commission plans:', error)
            throw error
        }
    }

    const fetchCommissionPlanFiltered = async (commissionPlanId: string) => {
        try {
            console.log('🔍 Fetching filtered commission plans for ID:', commissionPlanId)
            const response = await adminApi.post<CommissionPlanConfiguration[]>(
                '/GlobalConfiguration/Configuration/CommissionPlanConfiguration/filtered',
                {
                    CommissionPlanId: commissionPlanId
                }
            )
            console.log('✅ Filtered commission plans fetched:', response)
            return response
        } catch (error) {
            console.error('❌ Error fetching filtered commission plans:', error)
            throw error
        }
    }

    const saveCommissionPlan = async (planData: CommissionPlanConfiguration) => {
        try {
            console.log('💾 Saving commission plan:', planData)
            const response = await adminApi.post<CommissionPlanConfiguration>(
                '/GlobalConfiguration/Configuration/CommissionPlanConfiguration',
                planData
            )
            console.log('✅ Commission plan saved successfully:', response)
            return response
        } catch (error) {
            console.error('❌ Error saving commission plan:', error)
            throw error
        }
    }

    const updateCommissionPlan = async (id: string, partitionKey: string, planData: CommissionPlanConfiguration, isDeleted?: boolean) => {
        try {
            console.log('🔄 Updating commission plan:', { id, partitionKey, planData, isDeleted })
            
            // Use planData as base to preserve all backend properties (metadata)
            const payload: any = {
                ...planData,  // Spread all properties from planData (including metadata)
                id,           // Override with the provided values
                PartitionKey: partitionKey,
                GroupName: 'CommissionPlanConfiguration',
                DocumentType: 'Configuration'
            }
            
            // Add IsDeleted if provided
            if (isDeleted !== undefined) {
                payload.IsDeleted = isDeleted
            }
            
            console.log('🔄 Update payload with metadata:', {
                EnvironmentName: payload.EnvironmentName,
                TenantName: payload.TenantName,
                CreatedByProfileId: payload.CreatedByProfileId,
                CreatedDateTime: payload.CreatedDateTime
            })
            
            const response = await adminApi.put<CommissionPlanConfiguration>(
                '/GlobalConfiguration/Configuration/CommissionPlanConfiguration',
                payload
            )
            console.log('✅ Commission plan updated successfully:', response)
            return response
        } catch (error) {
            console.error('❌ Error updating commission plan:', error)
            throw error
        }
    }

    const calculateCommission = async (calculationRequest: any) => {
        try {
            console.log('🧮 Calculating commission:', calculationRequest)
            const response = await commissionPlanApi.post<any>(
                '/CommissionPlan/calculate',
                calculationRequest
            )
            console.log('✅ Commission calculation result:', response)
            return response
        } catch (error) {
            console.error('❌ Error calculating commission:', error)
            throw error
        }
    }

    return {
        fetchCommissionPlans,
        fetchCommissionPlanFiltered,
        saveCommissionPlan,
        updateCommissionPlan,
        calculateCommission
    }
}
